import multiRequest from '../shared/multiRequest';

function getBundlesCategories(cellphone) {
  const path = 'marketplace/bundles/categories';
  const url = cellphone ? `${path}?cellphone=${cellphone}` : path;
  return multiRequest([{ url, method: 'GET' }]);
}

function getBundlesPerCategory(code, name, offer, cellphone = '') {
  const path = 'marketplace/bundles/promotional';
  const queryString = new URLSearchParams({
    categoryCode: code,
    categoryName: name,
    offerCode: offer,
    ...(cellphone ? { cellphone } : {}),
  });
  const url = `${path}?${queryString}`;
  return multiRequest([{ url, method: 'GET' }]);
}

function getBundlesAds() {
  return multiRequest([
    {
      url: 'marketplace/bundles/purchasable',
      method: 'GET',
    },
  ]);
}

const getBundlesYourPint = () => {
  return multiRequest([
    {
      url: `marketplace/bundles/buildYourBundle?categoryCode=8&categoryName=ARMATUBOLSA`,
      method: 'GET',
    },
  ]);
};

const getEnlargeYourBag = (code, name) => {
  return multiRequest([
    {
      url: `marketplace/bundles/promotional?categoryCode=${code}&categoryName=${name}`,
      method: 'GET',
    },
  ]);
};

function getRecurringPlan() {
  return multiRequest([
    {
      url: 'marketplace/bundles/recurring-plan',
      method: 'GET',
    },
  ]);
}

function getOtherServices() {
  return multiRequest([
    {
      url: 'marketplace/other-services', // OTROS SERVICIOS
      method: 'GET',
    },
  ]);
}

function getRoamingStatus() {
  return multiRequest([
    {
      url: 'customer/roaming', // OTROS SERVICIOS
      method: 'GET',
    },
  ]);
}

function activateRoaming(code) {
  return multiRequest([
    {
      url: 'customer/complementary-service/activate', // OTROS SERVICIOS
      method: 'PUT',
      data: {
        code,
        activate: true,
      },
    },
  ]);
}

function getFaq() {
  return multiRequest([
    {
      url: 'contentful/faq/common',
      method: 'GET',
    },
  ]);
}

const buyBundle = (paymentMethod, code) => {
  return multiRequest([
    {
      url: `marketplace/bundles/purchase`,
      method: 'POST',
      data: {
        code,
        paymentMethod,
      },
    },
  ]);
};

const methodWebPaySend = (productId, segment, number) => {
  return multiRequest([
    {
      url: `marketplace/bundles/purchase/webpay?cellphone=${number}`,
      method: 'POST',
      data: {
        productId,
        segment,
      },
    },
  ]);
};

function methodWebPayInfo(orderId) {
  return multiRequest([
    {
      url: `marketplace/bundles/purchase/webpay/${orderId}`,
      method: 'GET',
    },
  ]);
}

const getCarrierBillingOffers = () => {
  // El parametro section es opcional, pero por front lo vamos a enviar siempre para obtener los mismos datos a la hora de validar disponibilidad y cachear en redis
  // Se establecen dos secciones validas en contentful home-marketplace y home-pagalo-en-tu-boleta
  return multiRequest([
    {
      url: `marketplace/carrier-billing/offers`,
      method: 'GET',
    },
  ]);
};

const getCarrierBillingOffersActive = idOffer => {
  return multiRequest([
    {
      url: `carrier-billing/offers?idOffer=${idOffer}`,
      method: 'GET',
    },
  ]);
};

const subscribeCarrierBilling = ({ offerId, otp }) => {
  return multiRequest([
    {
      url: `marketplace/carrier-billing/purchase`,
      method: 'POST',
      data: {
        offerId,
        otp,
      },
    },
  ]);
};

const checkEligibility = ({ carrierBilling }) => {
  return multiRequest([
    {
      url: 'marketplace/carrier-billing/purchase/validate',
      method: 'POST',
      data: {
        carrierBilling,
      },
    },
  ]);
};

const unsubscribeCarrierBilling = ({ offerId }) => {
  return multiRequest([
    {
      url: 'marketplace/carrier-billing/unsubscribe',
      method: 'PUT',
      data: {
        offerId,
      },
    },
  ]);
};

const getRemoveWelcomeBundleBAM = () => {
  return multiRequest([
    {
      url: 'marketplace/bundles/removeWelcomeBundle',
      method: 'GET',
    },
  ]);
};

const getEcommerceSales = () => {
  return multiRequest([
    {
      url: 'contentful/ecommerceSale',
      method: 'GET',
    },
  ]);
};

const getRechargePaymentMethods = () => {
  return multiRequest([
    {
      url: 'marketplace/recharge/payment-methods',
      method: 'GET',
    },
  ]);
};

const getOtherLinesWebpay = ({ productId, segment, cellphone, ratePlan }) => {
  return multiRequest([
    {
      url: `marketplace/other-lines/bundles/purchase/webpay&cellphone=${cellphone}&ratePlan=${ratePlan}`,
      method: 'POST',
      data: {
        productId,
        segment,
      },
    },
  ]);
};

const MarketplaceService = {
  getRechargePaymentMethods,
  getBundlesCategories,
  getBundlesPerCategory,
  getBundlesAds,
  getBundlesYourPint,
  getEnlargeYourBag,
  getOtherServices,
  getRoamingStatus,
  getRecurringPlan,
  activateRoaming,
  getFaq,
  buyBundle,
  methodWebPaySend,
  methodWebPayInfo,
  getCarrierBillingOffers,
  unsubscribeCarrierBilling,
  subscribeCarrierBilling,
  checkEligibility,
  getRemoveWelcomeBundleBAM,
  getEcommerceSales,
  getCarrierBillingOffersActive,
  getOtherLinesWebpay,
};

export default MarketplaceService;
